import { render } from "./MedicalHistoryVisitList.vue?vue&type=template&id=3b424508"
import script from "./MedicalHistoryVisitList.vue?vue&type=script&lang=js"
export * from "./MedicalHistoryVisitList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__